/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AnalyticsSignalName = {
  id: string;
  name: string;
};

/** @internal */
export const AnalyticsSignalName$inboundSchema: z.ZodMiniType<
  AnalyticsSignalName,
  unknown
> = z.object({
  id: z.string(),
  name: z.string(),
});

export function analyticsSignalNameFromJSON(
  jsonString: string,
): SafeParseResult<AnalyticsSignalName, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnalyticsSignalName$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnalyticsSignalName' from JSON`,
  );
}
